import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
} from "../../util/varios";

import moment from "moment";
import {
  DangerButton,
  InfoButton,
  SuccessButton,
} from "../../ui/buttons/Button";
import {
  Checkbox,
  Input,
  Radio,
  SearchInput,
  Select,
  Textarea,
} from "../../ui/inputs/Input";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import CatalogoOrganizacion from "../../catalogos/catalogoOrganizacion";
import CatalogoPersona from "../../catalogos/catalogoPersona";

export const ActualizarUsuarioGeneral = (props) => {
  const md5 = require("md5");
  const idusuario = JSON.parse(localStorage.getItem("idusuario"));
  const btnAcepta = useRef();
  const txtNombres = useRef();

  // --- CONFIGURACIÓN DE TABS (DINÁMICA) ---
  const getTabsConfig = () => {
    if (props.tabsConfig) return props.tabsConfig;

    const uniqueTabs = [
      ...new Set(props.permisosConfig?.map((item) => item.tab) || []),
    ];
    const subTabsConfig = uniqueTabs.map((tabName, index) => ({
      id: `sub-${tabName}`,
      label: tabName,
      colorClass:
        index === 0
          ? "bg-blue-100"
          : index === 1
            ? "bg-blue-200"
            : "bg-blue-300",
      filterValue: tabName,
    }));

    return [
      {
        id: "tab-datos",
        label: "Usuario",
        type: "static",
        colorClass: "bg-blue-100",
        contentId: "content-datos",
      },
      {
        id: "tab-permisos",
        label: "Permisos",
        type: "dynamic",
        colorClass: "bg-blue-200",
        contentId: "content-permisos",
        subTabs: subTabsConfig,
      },
    ];
  };

  const tabsConfig = getTabsConfig();

  // --- ESTADOS DE UI ---
  const [mostrar2, setMostrar2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [mostrarClave, setMostrarClave] = useState(false);
  const [mostrarClave1, setMostrarClave1] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema"),
  );

  // --- ESTADOS PRINCIPALES DE DATOS ---

  // 1. Datos de la tabla Usuario
  const [datosUsuario, setDatosUsuario] = useState({
    idusuario: "",
    login: "",
    passwd: "",
    idorganizacion: "",
    persona: "",
    clavesuperpresu: "", // Campo agregado para la clave de supervisor
    clavesuperteso: "", // Campo agregado para la clave de supervisor
    clavesuperadmin: "", // Campo agregado para la clave de supervisor
    superpresu: "",
    superadmin: "",
    superteso: "",
  });

  // 2. Datos de la tabla Persona
  const [datosPersonales, setDatosPersonales] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "V",
    sexo: "M",
  });

  // 3. Estados de Permisos
  const [permisos, setPermisos] = useState({});
  const [modulos, setModulos] = useState({});
  const [cambioAdmin, setCambioAdmin] = useState(false);
  const [cambioTeso, setCambioTeso] = useState(false);
  const [cambioPresu, setCambioPresu] = useState(false);

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  // --- EFECTOS Y CICLO DE VIDA ---

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    if (obj) setFechaSistema(obj.fechasistema);
    if (props.operacion) setOperacion(props.operacion);
  }, [props.operacion]);

  const initData = () => {
    console.log("🔵 INICIALIZANDO MODAL - Operación:", props.operacion);
    if (props.operacion) setOperacion(props.operacion);
    setDeshabilitado(props.deshabilitado);

    if (props.usuario) {
      setDatosUsuario({
        idusuario: props.usuario.idusuario || "",
        login: props.usuario.login || "",
        passwd: "",
        idorganizacion: props.usuario.idorganizacion || "",
        persona: props.usuario.persona || "",
        clavesuperpresu: props.usuario.clavesuperpresu || "", // Cargar valor existente
        clavesuperteso: props.usuario.clavesuperteso || "", // Cargar valor existente
        clavesuperadmin: props.usuario.clavesuperadmin || "", // Cargar valor existente
        superpresu: props.usuario.superpresu || "", // Cargar valor existente
        superadmin: props.usuario.superadmin || "", // Cargar valor existente
        superteso: props.usuario.superteso || "", // Cargar valor existente
      });
    } else {
      setDatosUsuario({
        idusuario: "",
        login: "",
        passwd: "",
        idorganizacion: "",
        persona: "",
        clavesuperpresu: "",
        clavesuperteso: "",
        clavesuperadmin: "",
      });
    }

    if (props.datospersonales) {
      setDatosPersonales({
        cedula: props.datospersonales.cedula || "",
        nombres: props.datospersonales.nombres || "",
        apellidos: props.datospersonales.apellidos || "",
        direccion: props.datospersonales.direccion || "",
        correoe: props.datospersonales.correoe || "",
        tlf1: props.datospersonales.tlf1 || "",
        tlf2: props.datospersonales.tlf2 || "",
        fnacimiento: props.datospersonales.fnacimiento
          ? moment.utc(props.datospersonales.fnacimiento).format("YYYY-MM-DD")
          : "",
        nacionalidad: props.datospersonales.nacionalidad || "V",
        sexo: props.datospersonales.sexo || "M",
      });
      setHabilitadoNU(false);
    } else {
      setDatosPersonales({
        cedula: "",
        nombres: "",
        apellidos: "",
        direccion: "",
        correoe: "",
        tlf1: "",
        tlf2: "",
        fnacimiento: "",
        nacionalidad: "V",
        sexo: "M",
      });
      setHabilitadoNU(true);
    }
    initializePermissions();
  };

  // --- MANEJADORES DE ESTADO ---

  const handleChangeUsuario = (e) => {
    const { name, value } = e.target;
    setDatosUsuario((prev) => {
      const newState = { ...prev, [name]: value };
      return newState;
    });
    if (name === "clavesuperadmin") {
      setCambioAdmin(true);
    } else if (name === "clavesuperteso") {
      setCambioTeso(true);
    } else if (name === "clavesuperpresu") {
      setCambioPresu(true);
    }
  };

  const handleChangePersona = (e) => {
    const { name, value } = e.target;
    setDatosPersonales((prev) => {
      const newState = { ...prev, [name]: value };
      return newState;
    });
  };

  const handleChangeChek = (event) => {
    const isChecked = event.target.checked ? "1" : "0";
    const name = event.target.name;
    const id = event.target.id;

    setPermisos((prev) => {
      let newVal;
      if (id.includes("_all")) {
        newVal = isChecked === "1" ? "1111" : "0000";
      } else {
        const currentVal = prev[name] || "0000";
        const index = parseInt(id.split("_").pop());
        newVal =
          currentVal.substring(0, index) +
          isChecked +
          currentVal.substring(index + 1);
      }
      const newState = { ...prev, [name]: newVal };
      return newState;
    });
  };

  const handleChangeOtro = (event) => {
    setModulos((prev) => {
      const modValue = event.target.value === "true" ? "1" : "0";
      const newState = {
        ...prev,
        [event.target.name]: modValue,
      };
      return newState;
    });
  };

  // --- FUNCIONES AUXILIARES ---

  const datosOrga = (idorganizacion) => {
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idorganizacion}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          if (response.data !== "") {
            setDatosUsuario((prev) => ({
              ...prev,
              idorganizacion: response.data.idorganizacion,
            }));
            setMsg(`Organización: ${response.data.nombre}`);
            setTitulo("Info");
          } else {
            setDatosUsuario((prev) => ({ ...prev, idorganizacion: "" }));
            setTitulo("Error");
            setMsg("La Organizacion no existe.");
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const datosRes = (cedula, tecla = null) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.ingresa === 0) {
            setDatosPersonales((prev) => ({
              ...prev,
              nombres: "",
              apellidos: "",
              direccion: "",
              correoe: "",
              tlf1: "",
              tlf2: "",
              fnacimiento: "",
              nacionalidad: "V",
              sexo: "M",
            }));
          }
          setHabilitadoNU(true);

          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            const newData = {
              cedula: response.data.cedula,
              nombres: response.data.nombres,
              apellidos: response.data.apellidos,
              direccion: response.data.direccion,
              correoe: response.data.correoe,
              tlf1: response.data.tlf1,
              tlf2: response.data.tlf2,
              fnacimiento: moment
                .utc(response.data.fnacimiento)
                .format("YYYY-MM-DD"),
              nacionalidad: response.data.nacionalidad,
              sexo: response.data.sexo,
            };
            setDatosPersonales(newData);
            setDatosUsuario((prev) => ({
              ...prev,
              persona: response.data.cedula,
            }));
            if (btnAcepta.current) btnAcepta.current.focus();
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            setDatosPersonales({
              cedula: cedula,
              nombres: "",
              apellidos: "",
              direccion: "",
              correoe: "",
              tlf1: "",
              tlf2: "",
              fnacimiento: "",
              nacionalidad: "V",
              sexo: "M",
            });
            if (tecla === 13) {
              setTimeout(() => {
                if (txtNombres.current) txtNombres.current.focus();
              }, 100);
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const validarOrg = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosOrga(event.target.value);
      } else {
        setDatosUsuario((prev) => ({ ...prev, idorganizacion: "" }));
      }
    }
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        datosRes(event.target.value, event.which);
      } else setDatosPersonales((prev) => ({ ...prev, nombres: "" }));
    }
  };

  const handleAceptaCatalogo = (idOrg, nomOrg) => {
    setMostrar2(false);
    setDatosUsuario((prev) => ({ ...prev, idorganizacion: idOrg }));
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer,
  ) => {
    setMostrar3(false);
    const newPersona = {
      cedula: cedPer,
      nombres: nomPer,
      apellidos: apePer,
      direccion: direPer,
      correoe: correoPer,
      tlf1: tlf1Per,
      tlf2: tlf2Per,
      fnacimiento: fnacPer,
      nacionalidad: nacPer,
      sexo: sexoPer,
    };
    setDatosPersonales(newPersona);
    setDatosUsuario((prev) => ({ ...prev, persona: cedPer }));
    setHabilitadoNU(false);
    setOperacionPer(0);
    if (btnAcepta.current) btnAcepta.current.focus();
  };

  const seleccionarPermisosUsuario = (id) => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/consulta/seleccionarpermisousuario?iduser=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          //if (response.data.length > 0) {
          localStorage.setItem("permisos", JSON.stringify(response.data));
          localStorage.setItem(
            "accaplicacion",
            JSON.stringify(response.data.accaplicacion),
          );
          localStorage.setItem(
            "accestructura",
            JSON.stringify(response.data.accestructura),
          );
          localStorage.setItem(
            "accorganizacion",
            JSON.stringify(response.data.accorganizacion),
          );
          localStorage.setItem(
            "accusuario",
            JSON.stringify(response.data.accusuario),
          );
          localStorage.setItem(
            "accpersona",
            JSON.stringify(response.data.accpersona),
          );

          localStorage.setItem("acciva", JSON.stringify(response.data.acciva));
          localStorage.setItem("accut", JSON.stringify(response.data.accut));
          localStorage.setItem(
            "acctasaactiva",
            JSON.stringify(response.data.acctasaactiva),
          );
          localStorage.setItem(
            "acctasapasiva",
            JSON.stringify(response.data.acctasapasiva),
          );
          localStorage.setItem(
            "acccambiofecha",
            JSON.stringify(response.data.acccambiofecha),
          );
          localStorage.setItem(
            "acccambioefiscal",
            JSON.stringify(response.data.acccambioefiscal),
          );

          /*inicio permisos catastro */
          localStorage.setItem(
            "accrepvalterreno",
            JSON.stringify(response.data.accrepvalterreno),
          );
          localStorage.setItem(
            "accrepdepreciacion",
            JSON.stringify(response.data.accrepdepreciacion),
          );
          localStorage.setItem(
            "accrepgenseccat",
            JSON.stringify(response.data.accrepgenseccat),
          );
          localStorage.setItem(
            "accrepconstancia",
            JSON.stringify(response.data.accrepconstancia),
          );
          localStorage.setItem(
            "accrepvalconstruc",
            JSON.stringify(response.data.accrepvalconstruc),
          );
          localStorage.setItem(
            "acccamstainmue",
            JSON.stringify(response.data.acccamstainmue),
          );
          localStorage.setItem(
            "accrepcedcat",
            JSON.stringify(response.data.accrepcedcat),
          );
          localStorage.setItem(
            "accrepceremp",
            JSON.stringify(response.data.accrepceremp),
          );
          localStorage.setItem(
            "accfichacat",
            JSON.stringify(response.data.accfichacat),
          );
          localStorage.setItem(
            "accvalorterrecat",
            JSON.stringify(response.data.accvalorterrecat),
          );
          localStorage.setItem(
            "accdepreciacioncat",
            JSON.stringify(response.data.accdepreciacioncat),
          );
          localStorage.setItem(
            "accavaluo",
            JSON.stringify(response.data.accavaluo),
          );
          localStorage.setItem(
            "accusuariocat",
            JSON.stringify(response.data.accusuariocat),
          );
          localStorage.setItem(
            "supercat",
            JSON.stringify(response.data.supercat),
          );
          localStorage.setItem(
            "accvalortipocat",
            JSON.stringify(response.data.accvalortipocat),
          );
          /* fin permisos catastro */

          /*inicio permisos acrividad economica */
          localStorage.setItem(
            "accdeclaraciones",
            JSON.stringify(response.data.accdeclaraciones),
          );
          localStorage.setItem(
            "accedocuenta",
            JSON.stringify(response.data.accedocuenta),
          );
          localStorage.setItem(
            "accexoncomercio",
            JSON.stringify(response.data.accexoncomercio),
          );
          localStorage.setItem(
            "accconfigcome",
            JSON.stringify(response.data.accconfigcome),
          );
          localStorage.setItem(
            "acccontribuyente",
            JSON.stringify(response.data.acccontribuyente),
          );
          localStorage.setItem(
            "accactividad",
            JSON.stringify(response.data.accactividad),
          );
          localStorage.setItem(
            "accusuariocome",
            JSON.stringify(response.data.accusuariocome),
          );
          localStorage.setItem(
            "accagente",
            JSON.stringify(response.data.accagente),
          );
          localStorage.setItem(
            "accreppatente",
            JSON.stringify(response.data.accreppatente),
          );
          localStorage.setItem(
            "accrepgensector",
            JSON.stringify(response.data.accrepgensector),
          );
          localStorage.setItem(
            "accrepactividad",
            JSON.stringify(response.data.accrepactividad),
          );
          localStorage.setItem(
            "accrepfecdecla",
            JSON.stringify(response.data.accrepfecdecla),
          );
          localStorage.setItem(
            "accrepmondecla",
            JSON.stringify(response.data.accrepmondecla),
          );
          localStorage.setItem(
            "accimppatente",
            JSON.stringify(response.data.accimppatente),
          );
          localStorage.setItem(
            "accimpedoctasectcome",
            JSON.stringify(response.data.accimpedoctasectcome),
          );
          localStorage.setItem(
            "accimptramites",
            JSON.stringify(response.data.accimptramites),
          );
          localStorage.setItem(
            "accpermdecla",
            JSON.stringify(response.data.accpermdecla),
          );
          localStorage.setItem(
            "accacreditacion",
            JSON.stringify(response.data.accacreditacion),
          );
          localStorage.setItem(
            "accrenovalicencia",
            JSON.stringify(response.data.accrenovalicencia),
          );
          localStorage.setItem(
            "acclicenciafunciona",
            JSON.stringify(response.data.acclicenciafunciona),
          );
          //  localStorage.setItem('liquidador', JSON.stringify(response.data.liquidador))
          localStorage.setItem(
            "accacticontri",
            JSON.stringify(response.data.accacticontri),
          );

          /* fin permisos acrividad economica */

          /* inicio permiso inmueble */
          localStorage.setItem(
            "accusrepmontaval",
            JSON.stringify(response.data.accusrepmontaval),
          );
          localStorage.setItem(
            "accedocuenta",
            JSON.stringify(response.data.accedocuenta),
          );
          localStorage.setItem(
            "accusrepsectcat",
            JSON.stringify(response.data.accusrepsectcat),
          );
          localStorage.setItem(
            "accusreptipconstruc",
            JSON.stringify(response.data.accusreptipconstruc),
          );
          localStorage.setItem(
            "accusrepmontdeud",
            JSON.stringify(response.data.accusrepmontdeud),
          );
          localStorage.setItem(
            "accusrepvalorconstruc",
            JSON.stringify(response.data.accusrepvalorconstruc),
          );
          localStorage.setItem(
            "accimpedoctasectinmue",
            JSON.stringify(response.data.accimpedoctasectinmue),
          );
          localStorage.setItem(
            "accperespinmue",
            JSON.stringify(response.data.accperespinmue),
          );
          localStorage.setItem(
            "accconfiginmue",
            JSON.stringify(response.data.accconfiginmue),
          );
          localStorage.setItem(
            "accvincuusoterre",
            JSON.stringify(response.data.accvincuusoterre),
          );

          localStorage.setItem(
            "accinmueble",
            JSON.stringify(response.data.accinmueble),
          );
          localStorage.setItem(
            "accvalfiscons",
            JSON.stringify(response.data.accvalfiscons),
          );
          localStorage.setItem(
            "accusuarioinmue",
            JSON.stringify(response.data.accusuarioinmue),
          );
          /* fin permiso inmueble */

          /* inicio permisos vehiculo */
          localStorage.setItem(
            "accedoctavehiculo",
            JSON.stringify(response.data.accusrepmontaval),
          );
          localStorage.setItem(
            "accconfigvehiculo",
            JSON.stringify(response.data.accconfigvehiculo),
          );
          localStorage.setItem(
            "accrepgenvehi",
            JSON.stringify(response.data.accrepgenvehi),
          );
          localStorage.setItem(
            "accrepcontvehideud",
            JSON.stringify(response.data.accrepcontvehideud),
          );
          localStorage.setItem(
            "accreptipvehi",
            JSON.stringify(response.data.accreptipvehi),
          );
          localStorage.setItem(
            "accvehiculo",
            JSON.stringify(response.data.accvehiculo),
          );
          localStorage.setItem(
            "accclasevehiculo",
            JSON.stringify(response.data.accclasevehiculo),
          );
          localStorage.setItem(
            "accusuariovehiculo",
            JSON.stringify(response.data.accusuariovehiculo),
          );

          /* fin permiso vehiculo */

          /* inicio permisos publicidad */
          localStorage.setItem(
            "accedoctapublicidad",
            JSON.stringify(response.data.accedoctapublicidad),
          );
          localStorage.setItem(
            "accstatuspubli",
            JSON.stringify(response.data.accstatuspubli),
          );

          localStorage.setItem(
            "accconfigpublicidad",
            JSON.stringify(response.data.accconfigpublicidad),
          );
          localStorage.setItem(
            "accrepgensecpubli",
            JSON.stringify(response.data.accrepgensecpubli),
          );
          localStorage.setItem(
            "accrepcontpublideud",
            JSON.stringify(response.data.accrepcontpublideud),
          );
          localStorage.setItem(
            "accreptippubli",
            JSON.stringify(response.data.accreptippubli),
          );
          localStorage.setItem(
            "accrepedoctapubli",
            JSON.stringify(response.data.accrepedoctapubli),
          );
          localStorage.setItem(
            "accpublicidad",
            JSON.stringify(response.data.accpublicidad),
          );
          localStorage.setItem(
            "accclasepublicidad",
            JSON.stringify(response.data.accclasepublicidad),
          );
          localStorage.setItem(
            "accusuariopublicidad",
            JSON.stringify(response.data.accusuariopublicidad),
          );

          /* fin permiso publicidad */

          /* inicio permiso renta inmobiliaria */
          localStorage.setItem(
            "accedoctarenta",
            JSON.stringify(response.data.accedoctarenta),
          );
          localStorage.setItem(
            "accconfigrenta",
            JSON.stringify(response.data.accconfigrenta),
          );
          localStorage.setItem(
            "accrepgenrenta",
            JSON.stringify(response.data.accrepgenrenta),
          );
          localStorage.setItem(
            "accurepcontratorenta",
            JSON.stringify(response.data.accurepcontratorenta),
          );
          localStorage.setItem(
            "accrepdeudarenta",
            JSON.stringify(response.data.accrepdeudarenta),
          );
          localStorage.setItem(
            "accrepedoctarenta",
            JSON.stringify(response.data.accrepedoctarenta),
          );
          localStorage.setItem(
            "accreptiporenta",
            JSON.stringify(response.data.accreptiporenta),
          );
          localStorage.setItem(
            "accrenta",
            JSON.stringify(response.data.accrenta),
          );
          localStorage.setItem(
            "acctiporenta",
            JSON.stringify(response.data.acctiporenta),
          );
          localStorage.setItem(
            "accusuariorenta",
            JSON.stringify(response.data.accusuariorenta),
          );

          /* fin permiso renta inmobiliaria */

          /*inicio permisos de presupuesto */
          localStorage.setItem(
            "acccatpro",
            JSON.stringify(response.data.acccatpro),
          );
          localStorage.setItem("accpuc", JSON.stringify(response.data.accpuc));
          localStorage.setItem(
            "accactivos",
            JSON.stringify(response.data.accactivos),
          );
          localStorage.setItem(
            "acccargos",
            JSON.stringify(response.data.acccargos),
          );
          localStorage.setItem(
            "superpresu",
            JSON.stringify(response.data.superpresu),
          );
          localStorage.setItem(
            "accpartext",
            JSON.stringify(response.data.accpartext),
          );
          localStorage.setItem(
            "accrepedofinanc",
            JSON.stringify(response.data.accrepedofinanc),
          );
          localStorage.setItem(
            "accrepcondicpar",
            JSON.stringify(response.data.accrepcondicpar),
          );
          localStorage.setItem(
            "accrepmovpresu",
            JSON.stringify(response.data.accrepmovpresu),
          );
          localStorage.setItem(
            "accrepcomprom",
            JSON.stringify(response.data.accrepcomprom),
          );
          localStorage.setItem(
            "accformpresu",
            JSON.stringify(response.data.accformpresu),
          );
          localStorage.setItem(
            "accaprobpresup",
            JSON.stringify(response.data.accaprobpresup),
          );
          localStorage.setItem(
            "accreppresuing",
            JSON.stringify(response.data.accreppresuing),
          );
          localStorage.setItem(
            "accaumentopart",
            JSON.stringify(response.data.accaumentopart),
          );
          localStorage.setItem(
            "accdisminucionpart",
            JSON.stringify(response.data.accdisminucionpart),
          );
          localStorage.setItem(
            "acctraslado",
            JSON.stringify(response.data.acctraslado),
          );
          localStorage.setItem(
            "acccompromiso",
            JSON.stringify(response.data.acccompromiso),
          );
          localStorage.setItem(
            "accaprocompro",
            JSON.stringify(response.data.accaprocompro),
          );
          localStorage.setItem(
            "accreppuc",
            JSON.stringify(response.data.accreppuc),
          );
          localStorage.setItem(
            "accrepformpresu",
            JSON.stringify(response.data.accrepformpresu),
          );
          localStorage.setItem(
            "acccontribuyente",
            JSON.stringify(response.data.acccontribuyente),
          );
          localStorage.setItem(
            "accefiscal",
            JSON.stringify(response.data.accefiscal),
          );
          localStorage.setItem(
            "accusuariopresu",
            JSON.stringify(response.data.accusuariopresu),
          );

          /* fin permisos de presupuesto */

          /*inicio permisos de administracion */
          localStorage.setItem(
            "superadmin",
            JSON.stringify(response.data.superadmin),
          );
          localStorage.setItem(
            "superteso",
            JSON.stringify(response.data.superteso),
          );

          localStorage.setItem(
            "accrereversegreso",
            JSON.stringify(response.data.accrereversegreso),
          );
          localStorage.setItem(
            "accdebito",
            JSON.stringify(response.data.accdebito),
          );
          localStorage.setItem(
            "accingresos",
            JSON.stringify(response.data.accingresos),
          );
          localStorage.setItem(
            "accaproborden",
            JSON.stringify(response.data.accaproborden),
          );
          localStorage.setItem(
            "accrepobras",
            JSON.stringify(response.data.accrepobras),
          );
          localStorage.setItem(
            "accmodreten",
            JSON.stringify(response.data.accmodreten),
          );
          localStorage.setItem(
            "accenvchecausar",
            JSON.stringify(response.data.accenvchecausar),
          );
          localStorage.setItem(
            "accfondotercero",
            JSON.stringify(response.data.accfondotercero),
          );
          localStorage.setItem(
            "acccausar",
            JSON.stringify(response.data.acccausar),
          );
          localStorage.setItem(
            "acccambioefiscal",
            JSON.stringify(response.data.acccambioefiscal),
          );
          localStorage.setItem(
            "acccredito",
            JSON.stringify(response.data.acccredito),
          );
          localStorage.setItem(
            "accpagoordenes",
            JSON.stringify(response.data.accpagoordenes),
          );
          localStorage.setItem(
            "acccontrolinterno",
            JSON.stringify(response.data.acccontrolinterno),
          );
          localStorage.setItem(
            "accespecial",
            JSON.stringify(response.data.accespecial),
          );
          localStorage.setItem(
            "accadministrador",
            JSON.stringify(response.data.accadministrador),
          );
          localStorage.setItem(
            "accrereversordenpago",
            JSON.stringify(response.data.accrereversordenpago),
          );
          localStorage.setItem(
            "accrepordenpago",
            JSON.stringify(response.data.accrepordenpago),
          );
          localStorage.setItem(
            "accrepbanco",
            JSON.stringify(response.data.accrepbanco),
          );
          localStorage.setItem(
            "accrepretencion",
            JSON.stringify(response.data.accrepretencion),
          );
          localStorage.setItem(
            "accrepfondoterc",
            JSON.stringify(response.data.accrepfondoterc),
          );
          localStorage.setItem(
            "accegresos",
            JSON.stringify(response.data.accegresos),
          );
          localStorage.setItem(
            "accdeposito",
            JSON.stringify(response.data.accdeposito),
          );
          localStorage.setItem(
            "acctransferenciabanc",
            JSON.stringify(response.data.acctransferenciabanc),
          );
          localStorage.setItem(
            "accrereverspagar",
            JSON.stringify(response.data.accrereverspagar),
          );
          localStorage.setItem(
            "accconciliacion",
            JSON.stringify(response.data.accconciliacion),
          );
          localStorage.setItem(
            "acccheqanul",
            JSON.stringify(response.data.acccheqanul),
          );
          localStorage.setItem(
            "accrereversdeposito",
            JSON.stringify(response.data.accrereversdeposito),
          );
          localStorage.setItem(
            "accbanco",
            JSON.stringify(response.data.accbanco),
          );
          localStorage.setItem(
            "acccuentabancaria",
            JSON.stringify(response.data.acccuentabancaria),
          );
          localStorage.setItem(
            "accdeclaraciones",
            JSON.stringify(response.data.accdeclaraciones),
          );
          localStorage.setItem(
            "accacticontri",
            JSON.stringify(response.data.accacticontri),
          );
          localStorage.setItem(
            "acctiporetencion",
            JSON.stringify(response.data.acctiporetencion),
          );
          localStorage.setItem(
            "accusuarioadmini",
            JSON.stringify(response.data.accusuarioadmini),
          );
          localStorage.setItem(
            "acctipoingreso",
            JSON.stringify(response.data.acctipoingreso),
          );
          localStorage.setItem(
            "accmovtransito",
            JSON.stringify(response.data.accmovtransito),
          );

          /* fin permisos de administracion */

          /* inicio de los permisos de compra */
          localStorage.setItem(
            "accaprosolicompra",
            JSON.stringify(response.data.accaprosolicompra),
          );
          localStorage.setItem(
            "acclisgencompraalmacen",
            JSON.stringify(response.data.acclisgencompraalmacen),
          );
          localStorage.setItem(
            "acclissolicompraalmacen",
            JSON.stringify(response.data.acclissolicompraalmacen),
          );
          localStorage.setItem(
            "accproveedor",
            JSON.stringify(response.data.accproveedor),
          );
          localStorage.setItem(
            "accunimedi",
            JSON.stringify(response.data.accunimedi),
          );
          localStorage.setItem(
            "acctipoproducto",
            JSON.stringify(response.data.acctipoproducto),
          );
          localStorage.setItem(
            "accproducto",
            JSON.stringify(response.data.accproducto),
          );

          localStorage.setItem(
            "accrequisicion",
            JSON.stringify(response.data.accrequisicion),
          );
          localStorage.setItem(
            "accsolicompra",
            JSON.stringify(response.data.accsolicompra),
          );

          localStorage.setItem(
            "accusuariocompra",
            JSON.stringify(response.data.accusuariocompra),
          );

          /* fin de los permisos de compra */

          /*inicio permisos de Gestion Comercial */
          localStorage.setItem(
            "accactudeuapuesta",
            JSON.stringify(response.data.accactudeuapuesta),
          );
          localStorage.setItem(
            "accactudeuindustria",
            JSON.stringify(response.data.accactudeuindustria),
          );
          localStorage.setItem(
            "accactudeuinmue",
            JSON.stringify(response.data.accactudeuinmue),
          );
          localStorage.setItem(
            "accactudeurenta",
            JSON.stringify(response.data.accactudeurenta),
          );
          localStorage.setItem(
            "accactudeuvehiculo",
            JSON.stringify(response.data.accactudeuvehiculo),
          );

          /* fin de los permisos de Gestion Comercial */

          /*inicio permisos de Contabilidad Fiscal */
          localStorage.setItem(
            "accreptransdiarias",
            JSON.stringify(response.data.accreptransdiarias),
          );
          

          /* fin de los permisos de Contabilidad Fiscal */
          setActivate(false);
        } else {
        }
        //}
        let textoMsg = "";
        if (operacion === 1)
          textoMsg = "ha sido registrado de manera satisfactoria.";
        else if (operacion === 2)
          textoMsg = "ha sido modificado de manera satisfactoria.";
        else if (operacion === 3)
          textoMsg = "ha sido eliminado de manera satisfactoria.";
        setMensaje({
          mostrar: true,
          titulo: "Exito.",
          texto: "El usuario " + id + " " + textoMsg,
          icono: "exito",
        });
        setActivate(false);
      })
      .catch((error) => {
        setActivate(false);
      });
  };

  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/comun/actualizarusuario/${operacion}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (idusuario === response.data.iduser) {
            seleccionarPermisosUsuario(response.data.iduser);
          } else {
            let textoMsg = "";
            if (operacion === 1)
              textoMsg = "ha sido registrado de manera satisfactoria.";
            else if (operacion === 2)
              textoMsg = "ha sido modificado de manera satisfactoria.";
            else if (operacion === 3)
              textoMsg = "ha sido eliminado de manera satisfactoria.";
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "El usuario " + response.data.iduser + " " + textoMsg,
              icono: "exito",
            });
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response ? error.response.data.message : error.message,
          icono: "error",
        });
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    let msg = "";

    if (datosUsuario.login.trim() === "") {
      setTitulo("Error");
      msg = "El Usuario no debe estar vacio";
      sigue = false;
    } else if (datosUsuario.passwd.trim() === "" && operacion === 1) {
      setTitulo("Error");
      msg = "La Contraseña no debe estar vacia";
      sigue = false;
    } else if (datosUsuario.idorganizacion.trim() === "") {
      setTitulo("Error");
      msg = "El Código de la Organización no debe estar vacio";
      sigue = false;
    } else if (
      cambioPresu &&
      permisos.superpresu === "true" &&
      datosUsuario.clavesuperpresu.trim() === ""
    ) {
      setTitulo("Error");
      msg = "La Clave del Supervisor de Presupuesto no debe estar vacia";
      sigue = false;
    } else if (
      cambioAdmin &&
      permisos.superadmin === "true" &&
      datosUsuario.clavesuperadmin.trim() === ""
    ) {
      setTitulo("Error");
      msg = "La Clave del Supervisor de Administracion no debe estar vacia";
      sigue = false;
    } else if (
      cambioTeso &&
      permisos.superteso === "true" &&
      datosUsuario.clavesuperteso.trim() === ""
    ) {
      setTitulo("Error");
      msg = "La Clave del Supervisor de Tesoreria no debe estar vacia";
      sigue = false;
    } else if (datosPersonales.cedula.trim() === "") {
      setTitulo("Error");
      msg = "La cedula no debe estar vacia";
      sigue = false;
    } else if (datosPersonales.nombres.trim() === "") {
      setTitulo("Error");
      msg = "Los nombres no deben estar vacios";
      sigue = false;
    } else if (datosPersonales.apellidos.trim() === "") {
      setTitulo("Error");
      msg = "Los Apellidos no deben estar vacios";
      sigue = false;
    } else if (datosPersonales.direccion.trim() === "") {
      setTitulo("Error");
      msg = "La direccion del Usuario no debe estar vacia";
      sigue = false;
    } else if (datosPersonales.fnacimiento.trim() === "") {
      setTitulo("Error");
      msg = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
    }

    if (sigue) {
      const finalData = { ...permisos, ...modulos };
      const usuarioPayload = {
        idusuario: datosUsuario.idusuario || "0",
        login: datosUsuario.login,
        passwd: datosUsuario.passwd,
        idorganizacion: datosUsuario.idorganizacion,
        persona: datosPersonales.cedula,
        //clavesuperpresu: datosUsuario.clavesuperpresu !== "" ? md5(datosUsuario.clavesuperpresu) : "", // Se incluye en el payload
        //clavesuperteso: datosUsuario.clavesuperteso !== "" ? md5(datosUsuario.clavesuperteso) : "", // Se incluye en el payload
        //clavesuperadmin: datosUsuario.clavesuperadmin !== "" ? md5(datosUsuario.clavesuperadmin) : "", // Se incluye en el payload
        ...finalData,
      };
      if (cambioPresu) {
        usuarioPayload.clavesuperpresu =
          datosUsuario.clavesuperpresu !== ""
            ? md5(datosUsuario.clavesuperpresu)
            : ""; // Se incluye en el payload
      }
      if (cambioTeso) {
        usuarioPayload.clavesuperteso =
          datosUsuario.clavesuperteso !== ""
            ? md5(datosUsuario.clavesuperteso)
            : ""; // Se incluye en el payload
      }
      if (cambioAdmin) {
        usuarioPayload.clavesuperadmin =
          datosUsuario.clavesuperadmin !== ""
            ? md5(datosUsuario.clavesuperadmin)
            : ""; // Se incluye en el payload
      }
      const personalPayload = {
        apellidos: datosPersonales.apellidos.trim().toUpperCase(),
        cedula: datosPersonales.cedula,
        correoe: datosPersonales.correoe,
        direccion: datosPersonales.direccion.trim().toUpperCase(),
        fnacimiento: datosPersonales.fnacimiento,
        nacionalidad: datosPersonales.nacionalidad,
        nombres: datosPersonales.nombres.trim().toUpperCase(),
        sexo: datosPersonales.sexo,
        tlf1: datosPersonales.tlf1,
        tlf2: datosPersonales.tlf2,
      };

      console.group("🚀 ENVIANDO DATOS AL SERVIDOR (VALIDACIÓN)");
      console.log("Estado Usuario:", datosUsuario);
      console.log("Estado Personales:", datosPersonales);
      console.log("Permisos/Módulos:", finalData);
      console.log("Payload Usuario:", usuarioPayload);
      console.log("Payload Personal:", personalPayload);
      console.groupEnd();

      setActivate(true);
      let body = {
        operacionper: operacionPer,
        usu: JSON.stringify([usuarioPayload]),
        perso: JSON.stringify([personalPayload]),
      };
      procesarRegistro(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: msg,
        icono: "informacion",
      });
    }
  };

  const initializePermissions = () => {
    let newPermisos = {};
    let newModulos = {};

    // 1. Inicializamos con los valores por defecto del config
    if (props.permisosConfig) {
      props.permisosConfig.forEach((item) => {
        if (item.type === "radio") {
          newModulos[item.key] = item.valor || "0";
        } else {
          newPermisos[item.key] = item.valor || "0000";
        }
      });
    }

    // 2. Sobrescribimos con los datos del usuario SI EXISTEN
    if (props.usuario) {
      Object.keys(newPermisos).forEach((key) => {
        // Usamos .trim() para limpiar espacios de la base de datos
        newPermisos[key] = props.usuario[key] === null ? props.usuario[key] : props.usuario[key].toString().trim();
      });
      Object.keys(newModulos).forEach((key) => {
        // Usamos .trim() para limpiar espacios de la base de datos
        if (props.usuario[key]) {
          newModulos[key] = props.usuario[key].toString().trim();
        }
      });
    }

    setPermisos(newPermisos);
    setModulos(newModulos);
  };

  const mostrarPassword = () => setMostrarClave(!mostrarClave);
  const mostrarPassword1 = () => setMostrarClave1(!mostrarClave1);
  const cancelar = () => {
    setTitulo("");
    setMsg("");
    setActivate(false);
    setCambioAdmin(false);
    setCambioTeso(false);
    setCambioPresu(false);
    props.onHideCancela();
  };
  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (props.render) props.render();
    cancelar();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={initData}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <Modal.Title style={{ color: "#fff" }}>
          {operacion === 1
            ? "Agregar Usuario."
            : operacion === 2
              ? "Editar Usuario."
              : operacion === 3
                ? "Eliminar Usuario."
                : "Consultar Usuario."}
        </Modal.Title>
        <a type="button" className="fw-bold text-light fs-6" onClick={cancelar}>
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <div>
          {/* --- NAVEGACIÓN PRINCIPAL (DINÁMICA) --- */}
          <ul className="nav mb-2" id="mainTab" role="tablist">
            {tabsConfig.map((tab, index) => (
              <li key={tab.id} className="nav-item" role="presentation">
                <a
                  className={`rounded nav-link ${index === 0 ? "active " + tab.colorClass : "text-light"} ${tab.colorClass}`}
                  id={`${tab.id}-tab`}
                  data-bs-toggle="tab"
                  href={`#${tab.id}-content`}
                  role="tab"
                  aria-controls={tab.id}
                  aria-selected={index === 0}
                >
                  {tab.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="tab-content" id="mainTabContent">
            {tabsConfig.map((tab, index) => (
              <div
                key={tab.id}
                className={`tab-pane fade ${index === 0 ? "show active" : ""}`}
                id={`${tab.id}-content`}
                role="tabpanel"
                aria-labelledby={`${tab.id}-tab`}
              >
                {/* --- CASO 1: CONTENIDO ESTÁTICO (DATOS USUARIO) --- */}
                {tab.type === "static" && (
                  <div className="col-12 m-0 p-0 d-flex flex-wrap">
                    <div class="col-3 m-0 mb-2 p-0">
                      <Input
                        label="Código:"
                        disabled={true}
                        value={datosUsuario.idusuario}
                        id="inputCodigo"
                        readOnly
                      />
                    </div>
                    <div class="col-9 m-0 mb-2 p-0 pl-2">
                      <Input
                        label="Usuario:"
                        autocomplete="off"
                        disabled={
                          operacion === 4 || operacion === 2
                            ? true
                            : deshabilitado
                        }
                        name="login"
                        value={datosUsuario.login}
                        onChange={handleChangeUsuario}
                      />
                    </div>
                    <div class="col-6 m-0 p-0 d-flex align-items-center">
                      <div className="col m-0 p-0">
                        <Input
                          label="Ingrese Contraseña:"
                          type={mostrarClave ? "text" : "password"}
                          disabled={
                            operacion === 4 || operacion === 2
                              ? true
                              : deshabilitado
                          }
                          name="passwd"
                          value={datosUsuario.passwd}
                          onChange={handleChangeUsuario}
                        />
                      </div>
                      <div className="col-auto m-0 p-0 input-group-sm">
                        <InfoButton
                          icon="m-0"
                          className="rounded-0 m-0"
                          disabled={
                            operacion === 4 || operacion === 2
                              ? true
                              : deshabilitado
                          }
                          onClick={mostrarPassword}
                        >
                          <i
                            disabled={deshabilitado}
                            className="fa fa-eye-slash"
                          ></i>
                        </InfoButton>
                      </div>
                    </div>
                    <div class="col-6 m-0 p-0 d-flex align-items-center pl-2">
                      <div className="col m-0 p-0">
                        <Input
                          label="Confirmar Contraseña:"
                          type={mostrarClave1 ? "text" : "password"}
                          disabled={
                            operacion === 4 || operacion === 2
                              ? true
                              : deshabilitado
                          }
                          name="confirmPasswd"
                          onChange={handleChangeUsuario}
                        />
                      </div>
                      <div className="col-auto m-0 p-0 input-group-sm">
                        <InfoButton
                          icon="m-0"
                          className="rounded-0 m-0"
                          disabled={
                            operacion === 4 || operacion === 2
                              ? true
                              : deshabilitado
                          }
                          onClick={mostrarPassword1}
                        >
                          <i
                            disabled={deshabilitado}
                            className="fa fa-eye-slash"
                          ></i>
                        </InfoButton>
                      </div>
                    </div>

                    <fieldset className="col-12 m-0 p-2 d-flex border-azul rounded">
                      <legend className="float-none w-auto m-0">
                        Organización
                      </legend>
                      <div className="col-3 m-0 p-0">
                        <SearchInput
                          label="Código:"
                          disabled={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          name="idorganizacion"
                          value={datosUsuario.idorganizacion}
                          onKeyUp={validarOrg}
                          onBlur={validarOrg}
                          disabledButton={
                            operacion === 1 || operacion === 2 ? false : true
                          }
                          onClickButton={() => setMostrar2(true)}
                        />
                      </div>
                      <Input
                        disabled={true}
                        value={titulo === "Info" ? msg : ""}
                        readOnly
                      />
                    </fieldset>

                    <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
                      <legend className="float-none w-auto m-0">
                        Datos Personales
                      </legend>
                      <div class="col-5 m-0 mb-2 p-0 d-flex">
                        <div className="col m-0 p-0">
                          <Select
                            label="Nac.:"
                            disabled={!habilitadoNU}
                            name="nacionalidad"
                            value={datosPersonales.nacionalidad}
                            onChange={handleChangePersona}
                          >
                            <option key="0" value="V">
                              V
                            </option>
                            <option key="1" value="E">
                              E
                            </option>
                          </Select>
                        </div>
                        <div className="col-auto m-0 p-0">
                          <SearchInput
                            disabled={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            name="cedula"
                            value={datosPersonales.cedula}
                            onChange={handleChangePersona}
                            onKeyUp={validarPersona}
                            onBlur={validarPersona}
                            disabledButton={
                              operacion === 1 || operacion === 2 ? false : true
                            }
                            onClickButton={(e) => {
                              e.preventDefault();
                              if (operacion < 3) setMostrar3(true);
                            }}
                          />
                        </div>
                      </div>
                      <div class="col-4 m-0 mb-2 ml-auto p-0">
                        <Input
                          label="Fecha de Nacimiento:"
                          type="date"
                          disabled={!habilitadoNU}
                          name="fnacimiento"
                          max={fechaSistema}
                          value={datosPersonales.fnacimiento}
                          onChange={handleChangePersona}
                        />
                      </div>
                      <div class="col-6 m-0 mb-2 p-0">
                        <Input
                          label="Nombres:"
                          disabled={!habilitadoNU}
                          name="nombres"
                          value={datosPersonales.nombres}
                          onChange={handleChangePersona}
                          ref={txtNombres}
                        />
                      </div>
                      <div class="col-6 m-0 mb-2 p-0 pl-2">
                        <Input
                          label="Apellidos:"
                          disabled={!habilitadoNU}
                          name="apellidos"
                          value={datosPersonales.apellidos}
                          onChange={handleChangePersona}
                        />
                      </div>
                      <div class="col-12 m-0 mb-2 p-0">
                        <Textarea
                          label="Dirección:"
                          style={{ height: 70 }}
                          disabled={!habilitadoNU}
                          name="direccion"
                          value={datosPersonales.direccion}
                          onChange={handleChangePersona}
                        />
                      </div>
                      <div class="col-4 m-0 p-0">
                        <Input
                          label="Correo:"
                          disabled={!habilitadoNU}
                          name="correoe"
                          value={datosPersonales.correoe}
                          onChange={handleChangePersona}
                        />
                      </div>
                      <div class="col-3 m-0 p-0 pl-2">
                        <Input
                          label="Telefono:"
                          disabled={!habilitadoNU}
                          name="tlf1"
                          placeholder="0000-0000000"
                          value={datosPersonales.tlf1}
                          onChange={handleChangePersona}
                        />
                      </div>
                      <div class="col-3 m-0 p-0 pl-2">
                        <Input
                          label="Celular:"
                          disabled={!habilitadoNU}
                          name="tlf2"
                          placeholder="0000-0000000"
                          value={datosPersonales.tlf2}
                          onChange={handleChangePersona}
                        />
                      </div>
                      <div class="col-2 m-0 p-0 pl-2">
                        <Select
                          label="Sexo:"
                          disabled={!habilitadoNU}
                          name="sexo"
                          value={datosPersonales.sexo}
                          onChange={handleChangePersona}
                        >
                          <option key="0" value="M">
                            M
                          </option>
                          <option key="1" value="F">
                            F
                          </option>
                        </Select>
                      </div>
                    </fieldset>
                  </div>
                )}

                {/* --- CASO 2: CONTENIDO DINÁMICO (PERMISOS) --- */}
                {tab.type === "dynamic" && (
                  <div>
                    {/* Sub-Navegación (Generada dinámicamente) */}
                    {tab.subTabs && tab.subTabs.length > 0 && (
                      <ul className="nav mb-2" id="subTab" role="tablist">
                        {tab.subTabs.map((subTab, idx) => (
                          <li
                            key={subTab.id}
                            className="nav-item"
                            role="presentation"
                          >
                            <a
                              className={`rounded nav-link ${idx === 0 ? "active " + subTab.colorClass : "text-light"} ${subTab.colorClass}`}
                              id={`${subTab.id}-tab`}
                              data-bs-toggle="tab"
                              href={`#${subTab.id}-content`}
                              role="tab"
                              aria-controls={subTab.id}
                              aria-selected={idx === 0}
                            >
                              {subTab.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}

                    {/* Contenido de Sub-Pestañas */}
                    <div className="tab-content" id="subTabContent">
                      {tab.subTabs && tab.subTabs.length > 0 ? (
                        tab.subTabs.map((subTab, idx) => (
                          <div
                            key={subTab.id}
                            className={`tab-pane fade ${idx === 0 ? "show active" : ""}`}
                            id={`${subTab.id}-content`}
                            role="tabpanel"
                            aria-labelledby={`${subTab.id}-tab`}
                          >
                            <div className="col-md-12 row mx-auto border-azul rounded">
                              {props.permisosConfig &&
                                props.permisosConfig
                                  .filter(
                                    (item) => item.tab === subTab.filterValue,
                                  )
                                  .map((item) => {
                                    // --- BLOQUE ESPECIAL PARA SUPERVISOR PRESUPUESTO ---
                                    if (item.key === "superpresu") {
                                      return (
                                        <div
                                          key={item.key}
                                          className="col-md-12 row mx-auto rounded border my-2 py-2 align-items-center"
                                        >
                                          <div className="col-md-5">
                                            <Checkbox
                                              label={item.label}
                                              name={item.key}
                                              value={datosUsuario.superpresu}
                                              disabled={deshabilitado}
                                              checked={
                                                permisos[item.key] === "true"
                                              }
                                              onChange={(e) => {
                                                const val = e.target.checked
                                                  ? "true"
                                                  : "false";
                                                if (val === "false")
                                                  datosUsuario.clavesuperpresu =
                                                    "";
                                                setPermisos((prev) => ({
                                                  ...prev,
                                                  [item.key]: val,
                                                }));
                                                setCambioPresu(true);
                                              }}
                                            />
                                          </div>
                                          <div className="col">
                                            <Input
                                              type="password"
                                              placeholder="Ingrese Clave Supervisor"
                                              name="clavesuperpresu"
                                              value={
                                                datosUsuario.clavesuperpresu
                                              }
                                              onChange={handleChangeUsuario}
                                              disabled={
                                                permisos[item.key] !== "true" ||
                                                deshabilitado
                                              }
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    // --- FIN BLOQUE ESPECIAL ---

                                    // --- BLOQUE ESPECIAL PARA SUPERVISOR TESORERIA ---
                                    if (item.key === "superteso") {
                                      return (
                                        <div
                                          key={item.key}
                                          className="col-md-12 row mx-auto rounded border my-2 py-2 align-items-center"
                                        >
                                          <div className="col-md-5">
                                            <Checkbox
                                              label={item.label}
                                              name={item.key}
                                              disabled={deshabilitado}
                                              checked={
                                                permisos[item.key] === "true"
                                              }
                                              onChange={(e) => {
                                                const val = e.target.checked
                                                  ? "true"
                                                  : "false";
                                                if (val === "false")
                                                  datosUsuario.clavesuperteso =
                                                    "";
                                                setPermisos((prev) => ({
                                                  ...prev,
                                                  [item.key]: val,
                                                }));
                                                setCambioTeso(true);
                                              }}
                                            />
                                          </div>
                                          <div className="col">
                                            <Input
                                              type="password"
                                              placeholder="Ingrese Clave Supervisor"
                                              name="clavesuperteso"
                                              value={
                                                datosUsuario.clavesuperteso
                                              }
                                              onChange={handleChangeUsuario}
                                              disabled={
                                                permisos[item.key] !== "true" ||
                                                deshabilitado
                                              }
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    // --- FIN BLOQUE ESPECIAL ---

                                    // --- BLOQUE ESPECIAL PARA SUPERVISOR ADMINISTRACION ---
                                    if (item.key === "superadmin") {
                                      return (
                                        <div
                                          key={item.key}
                                          className="col-md-12 row mx-auto rounded border my-2 py-2 align-items-center"
                                        >
                                          <div className="col-md-5">
                                            <Checkbox
                                              label={item.label}
                                              name={item.key}
                                              disabled={deshabilitado}
                                              checked={
                                                permisos[item.key] === "true"
                                              }
                                              onChange={(e) => {
                                                const val = e.target.checked
                                                  ? "true"
                                                  : "false";
                                                if (val === "false")
                                                  datosUsuario.clavesuperadmin =
                                                    "";
                                                setPermisos((prev) => ({
                                                  ...prev,
                                                  [item.key]: val,
                                                }));
                                                setCambioAdmin(true);
                                              }}
                                            />
                                          </div>
                                          <div className="col">
                                            <Input
                                              type="password"
                                              placeholder="Ingrese Clave Supervisor"
                                              name="clavesuperadmin"
                                              value={
                                                datosUsuario.clavesuperadmin
                                              }
                                              onChange={handleChangeUsuario}
                                              disabled={
                                                permisos[item.key] !== "true" ||
                                                deshabilitado
                                              }
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    // --- FIN BLOQUE ESPECIAL ---

                                    return (
                                      <div
                                        key={item.key}
                                        className="col-md-12 row mx-auto rounded border my-2 py-2"
                                      >
                                        <div className="col-md-5">
                                          {item.label}
                                        </div>
                                        <div className="col px-0 d-flex gap-2">
                                          {item.type === "check" ? (
                                            <>
                                              <Checkbox
                                                label="Consultar"
                                                id={`chk_${item.key}_0`}
                                                name={item.key}
                                                disabled={deshabilitado}
                                                checked={
                                                  permisos[item.key]
                                                    ? permisos[
                                                        item.key
                                                      ].substring(0, 1) === "1"
                                                    : false
                                                }
                                                onChange={handleChangeChek}
                                              />
                                              <Checkbox
                                                label="Incluir"
                                                id={`chk_${item.key}_1`}
                                                name={item.key}
                                                disabled={deshabilitado}
                                                checked={
                                                  permisos[item.key]
                                                    ? permisos[
                                                        item.key
                                                      ].substring(1, 2) === "1"
                                                    : false
                                                }
                                                onChange={handleChangeChek}
                                              />
                                              <Checkbox
                                                label="Editar"
                                                id={`chk_${item.key}_2`}
                                                name={item.key}
                                                disabled={deshabilitado}
                                                checked={
                                                  permisos[item.key]
                                                    ? permisos[
                                                        item.key
                                                      ].substring(2, 3) === "1"
                                                    : false
                                                }
                                                onChange={handleChangeChek}
                                              />
                                              <Checkbox
                                                label="Eliminar"
                                                id={`chk_${item.key}_3`}
                                                name={item.key}
                                                disabled={deshabilitado}
                                                checked={
                                                  permisos[item.key]
                                                    ? permisos[
                                                        item.key
                                                      ].substring(3, 4) === "1"
                                                    : false
                                                }
                                                onChange={handleChangeChek}
                                              />
                                              <Checkbox
                                                label="Todas"
                                                id={`chk_${item.key}_all`}
                                                name={item.key}
                                                disabled={deshabilitado}
                                                checked={
                                                  permisos[item.key] === "1111"
                                                }
                                                onChange={handleChangeChek}
                                              />
                                            </>
                                          ) : (
                                            <>
                                              <div className="form-check form-check-inline col">
                                                <Radio
                                                  label={`Disponible`}
                                                  name={item.key}
                                                  disabled={deshabilitado}
                                                  id={`radio_${item.key}_Disp`}
                                                  value={true}
                                                  checked={
                                                    modulos[item.key] !== null
                                                      ? modulos[item.key] ===
                                                        "1"
                                                        ? true
                                                        : false
                                                      : false
                                                  }
                                                  onChange={handleChangeOtro}
                                                />
                                              </div>
                                              <div className="form-check form-check-inline col">
                                                <Radio
                                                  label="No Disponible"
                                                  name={item.key}
                                                  disabled={deshabilitado}
                                                  id={`radio_${item.key}_NoDisp`}
                                                  value={false}
                                                  checked={
                                                    modulos[item.key] !== null
                                                      ? modulos[item.key] ===
                                                        "0"
                                                        ? true
                                                        : false
                                                      : false
                                                  }
                                                  onChange={handleChangeOtro}
                                                />
                                              </div>
                                            </>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="col-md-12 row mx-auto border-azul rounded">
                          {props.permisosConfig &&
                            props.permisosConfig.map((item) => {
                              // --- BLOQUE ESPECIAL PARA SUPERVISOR PRESUPUESTO (Flat view) ---
                              if (item.key === "superpresu") {
                                return (
                                  <div
                                    key={item.key}
                                    className="col-12 m-0 p-2 border rounded d-flex align-items-center"
                                  >
                                    <div
                                      className="fw-bold me-3"
                                      style={{ minWidth: "200px" }}
                                    >
                                      {item.label}:
                                    </div>
                                    <Checkbox
                                      label="Habilitar"
                                      name={item.key}
                                      disabled={deshabilitado}
                                      checked={permisos[item.key] === "true"}
                                      onChange={(e) => {
                                        const val = e.target.checked
                                          ? "true"
                                          : "false";
                                        if (val === "false")
                                          datosUsuario.clavesuperpresu = "";
                                        setPermisos((prev) => ({
                                          ...prev,
                                          [item.key]: val,
                                        }));
                                        setCambioPresu(true);
                                      }}
                                    />
                                    <Input
                                      type="password"
                                      placeholder="Clave Supervisor"
                                      name="clavesuperpresu"
                                      value={datosUsuario.clavesuperpresu}
                                      onChange={handleChangeUsuario}
                                      disabled={
                                        permisos[item.key] !== "true" ||
                                        deshabilitado
                                      }
                                      className="ms-3"
                                    />
                                  </div>
                                );
                              }

                              // --- BLOQUE ESPECIAL PARA SUPERVISOR TESORERIA (Flat view) ---
                              if (item.key === "superteso") {
                                return (
                                  <div
                                    key={item.key}
                                    className="col-12 m-0 p-2 border rounded d-flex align-items-center"
                                  >
                                    <div
                                      className="fw-bold me-3"
                                      style={{ minWidth: "200px" }}
                                    >
                                      {item.label}:
                                    </div>
                                    <Checkbox
                                      label="Habilitar"
                                      name={item.key}
                                      disabled={deshabilitado}
                                      checked={permisos[item.key] === "true"}
                                      onChange={(e) => {
                                        const val = e.target.checked
                                          ? "true"
                                          : "false";
                                        if (val === "false")
                                          datosUsuario.clavesuperteso = "";
                                        setPermisos((prev) => ({
                                          ...prev,
                                          [item.key]: val,
                                        }));
                                        setCambioTeso(true);
                                      }}
                                    />
                                    <Input
                                      type="password"
                                      placeholder="Clave Supervisor"
                                      name="clavesuperteso"
                                      value={datosUsuario.clavesuperteso}
                                      onChange={handleChangeUsuario}
                                      disabled={
                                        permisos[item.key] !== "true" ||
                                        deshabilitado
                                      }
                                      className="ms-3"
                                    />
                                  </div>
                                );
                              }

                              // --- BLOQUE ESPECIAL PARA SUPERVISOR ADMINISTRACION (Flat view) ---
                              if (item.key === "superadmin") {
                                return (
                                  <div
                                    key={item.key}
                                    className="col-12 m-0 p-2 border rounded d-flex align-items-center"
                                  >
                                    <div
                                      className="fw-bold me-3"
                                      style={{ minWidth: "200px" }}
                                    >
                                      {item.label}:
                                    </div>
                                    <Checkbox
                                      label="Habilitar"
                                      name={item.key}
                                      disabled={deshabilitado}
                                      checked={permisos[item.key] === "true"}
                                      onChange={(e) => {
                                        const val = e.target.checked
                                          ? "true"
                                          : "false";
                                        if (val === "false")
                                          datosUsuario.clavesuperadmin = "";
                                        setPermisos((prev) => ({
                                          ...prev,
                                          [item.key]: val,
                                        }));
                                        setCambioAdmin(true);
                                      }}
                                    />
                                    <Input
                                      type="password"
                                      placeholder="Clave Supervisor"
                                      name="clavesuperadmin"
                                      value={datosUsuario.clavesuperadmin}
                                      onChange={handleChangeUsuario}
                                      disabled={
                                        permisos[item.key] !== "true" ||
                                        deshabilitado
                                      }
                                      className="ms-3"
                                    />
                                  </div>
                                );
                              }

                              return (
                                <div
                                  key={item.key}
                                  className="col-12 m-0 p-2 border rounded d-flex"
                                >
                                  <span className="fw-bold">{item.label}:</span>
                                  <div className="col d-flex gap-2">
                                    {item.type === "check" ? (
                                      <>
                                        <Checkbox
                                          label="Consultar"
                                          id={`chk_${item.key}_0`}
                                          name={item.key}
                                          disabled={deshabilitado}
                                          checked={
                                            permisos[item.key]
                                              ? permisos[item.key].substring(
                                                  0,
                                                  1,
                                                ) === "1"
                                              : false
                                          }
                                          onChange={handleChangeChek}
                                        />
                                        <Checkbox
                                          label="Incluir"
                                          id={`chk_${item.key}_1`}
                                          name={item.key}
                                          disabled={deshabilitado}
                                          checked={
                                            permisos[item.key]
                                              ? permisos[item.key].substring(
                                                  1,
                                                  2,
                                                ) === "1"
                                              : false
                                          }
                                          onChange={handleChangeChek}
                                        />
                                        <Checkbox
                                          label="Editar"
                                          id={`chk_${item.key}_2`}
                                          name={item.key}
                                          disabled={deshabilitado}
                                          checked={
                                            permisos[item.key]
                                              ? permisos[item.key].substring(
                                                  2,
                                                  3,
                                                ) === "1"
                                              : false
                                          }
                                          onChange={handleChangeChek}
                                        />
                                        <Checkbox
                                          label="Eliminar"
                                          id={`chk_${item.key}_3`}
                                          name={item.key}
                                          disabled={deshabilitado}
                                          checked={
                                            permisos[item.key]
                                              ? permisos[item.key].substring(
                                                  3,
                                                  4,
                                                ) === "1"
                                              : false
                                          }
                                          onChange={handleChangeChek}
                                        />
                                        <Checkbox
                                          label="Todas"
                                          id={`chk_${item.key}_all`}
                                          name={item.key}
                                          disabled={deshabilitado}
                                          checked={
                                            permisos[item.key] === "1111"
                                          }
                                          onChange={handleChangeChek}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <Radio
                                          label="Disponible"
                                          name={item.key}
                                          disabled={deshabilitado}
                                          id={`radio_${item.key}_Disp`}
                                          value={true}
                                          checked={
                                            modulos[item.key] === "1"
                                              ? true
                                              : false
                                          }
                                          onChange={handleChangeOtro}
                                        />
                                        <Radio
                                          label="No Disponible"
                                          name={item.key}
                                          disabled={deshabilitado}
                                          id={`radio_${item.key}_NoDisp`}
                                          value={false}
                                          checked={
                                            modulos[item.key] === "0"
                                              ? true
                                              : false
                                          }
                                          onChange={handleChangeOtro}
                                        />
                                      </>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton ref={btnAcepta} onClick={onChangeValidar}>
          Aceptar
        </SuccessButton>
        <DangerButton onClick={cancelar}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <CatalogoOrganizacion
        titulo={titulo}
        mensaje={msg}
        show={mostrar2}
        onHideCancelaCatOrg={() => setMostrar2(false)}
        onHideAceptaCatOrg={handleAceptaCatalogo}
      />
      <CatalogoPersona
        titulo={titulo}
        mensaje={msg}
        show={mostrar3}
        onHideCancelaCatPer={() => setMostrar3(false)}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
